import { Events } from 'global/constants';
import { mapOptions, generateInput } from './inkTonerDropdownUtility';
import getDropdownData from './inkTonerDropdownModels';

export default class InkTonerDropdownStore {
	constructor(assistedSearchIndex, initialDropdownData, containerElement) {
		this.assistedSearchIndex = assistedSearchIndex;
		this.containerElement = containerElement;
		this.oldStoreData = {};
		this.newStoreData = Object.assign({}, initialDropdownData);
		window.od.events.subscribe(
			Events.INKTONER_STORE_UPDATE,
			this.updateStore.bind(this),
		);
	}

	publish(eventName) {
		window.od.events.publish(eventName, {
			assistedSearchIndex: this.assistedSearchIndex,
			oldValue: this.oldStoreData,
			newValue: this.newStoreData,
		});
	}

	updateStore(data) {
		if (data.payload.assistedSearchIndex === this.assistedSearchIndex) {
			const nextDropdownId = this.getNextDropdownId(
				data.payload.changedDropdown,
			);

			this.copyNewStoreToOld();
			this.updateSelectedOptions(data);
			this.resetSubsequentDropdowns(data);

			if (nextDropdownId === null) {
				this.buildForm(data, this.containerElement);
				this.submitForm(this.containerElement);
			} else {
				this.updateStoreOptions(this.newStoreData, nextDropdownId);
			}
		}
	}

	copyNewStoreToOld() {
		this.oldStoreData = JSON.parse(JSON.stringify(this.newStoreData));
	}

	updateSelectedOptions(data) {
		const { changedDropdown } = data.payload;
		const newDropdownObject = {
			value: data.payload.dropdownValue.value,
			label: data.payload.dropdownValue.label,
			deviceUrl: data.payload.dropdownValue.deviceUrl || null,
		};

		this.newStoreData[changedDropdown].selectedOption = Object.assign(
			{},
			this.newStoreData[changedDropdown].selectedOption,
			newDropdownObject,
		);
	}

	resetSubsequentDropdowns(data) {
		const subsequentDropdowns =
			this.newStoreData[data.payload.changedDropdown].propertiesToReset;
		subsequentDropdowns.forEach(dropdown => {
			this.newStoreData[dropdown].options = [];
		});
	}

	updateStoreOptions(data, nextDropdownId) {
		return getDropdownData[nextDropdownId](data).then(nextDropdownData => {
			this.updateNewStore(nextDropdownData, nextDropdownId);
			this.publish(Events.INKTONER_STORE_CHANGED);
		});
	}

	updateNewStore(nextDropdownData, nextDropdownId) {
		const updatedData = this.generateNewData(nextDropdownData, nextDropdownId);
		this.newStoreData = Object.assign({}, this.newStoreData, updatedData);
	}

	generateNewData(nextDropdownData, nextDropdownId) {
		return {
			[nextDropdownId]: {
				propertiesToReset: this.newStoreData[nextDropdownId].propertiesToReset,
				selectedOption: {},
				options: mapOptions(nextDropdownData.data),
			},
		};
	}

	getNextDropdownId(changedDropdown) {
		const keys = Object.keys(this.newStoreData);
		const keysIndex = keys.indexOf(changedDropdown) + 1;
		return keysIndex < keys.length ? keys[keysIndex % keys.length] : null;
	}

	buildForm(data, form) {
		form.action = this.createFormAction(data);
		this.attachHiddenInput(form, data);
	}

	submitForm(form) {
		return form.submit();
	}

	createFormAction(data) {
		const seoFriendlyUrl = data.payload.dropdownValue.deviceUrl;
		const inkTonerURL =
			window.od.searchOptionsInkToner.inkTonerURL || 'ink-toner-finder';

		return seoFriendlyUrl
			? `${inkTonerURL}/${seoFriendlyUrl}`
			: `${inkTonerURL}/device`;
	}

	attachHiddenInput(form, data) {
		const isOemEnabledBrand =
			window.od.searchOptionsInkToner.isOemEnabledBrand || false;
		const seoFriendlyUrl = data.payload.dropdownValue.deviceUrl;

		if (!isOemEnabledBrand && seoFriendlyUrl) return;

		const queryString = this.createInputQueryString(data, isOemEnabledBrand);
		form.appendChild(generateInput('q', queryString, 'hidden'));
	}

	createInputQueryString(data, isOemEnabledBrand) {
		const deviceId = data.payload.dropdownValue.value;
		const brandName = window.od.inkTonerOptions.brand[0].name.replace(' ', '+');

		const stringVal = isOemEnabledBrand
			? `::deviceId:${deviceId}:brandName:${brandName}`
			: `::deviceId:${deviceId}`;

		return stringVal;
	}
}
